import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SEO from '../components/SEO';
import { useRedirectUnauthorized } from '../hooks/useRedirectUnauthenticated';
import { CenteredFormContainer } from '../components/forms/style';
import { LoginForm } from '../components/forms/LoginForm';
import { Card, Row, Typography } from 'antd';
import { Dont_have_an_account, Log_in, Sign_up } from '../helpers/dictionary';
import { ContainerWithBackground } from '../components/styles/Container';
import { login } from '../actions/auth';
import { NoBreakSpace } from '../helpers/constants';
import Link from 'next/link';

interface LoginArgs {
    countryCode: string;
    phone: number;
    password: string;
}

const Login = () => {
    useRedirectUnauthorized({ allowPros: false, allowClients: false });
    const dispatch = useDispatch();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const lang = useSelector((state: any) => state.settings.lang as string);
    const handleSubmit = async ({ password, phone, countryCode }: LoginArgs): Promise<void> => {
        // @ts-ignore
        return dispatch(login({ number: phone, countryCode, password }));
    };

    return (
        <ContainerWithBackground>
            <SEO title="Login" />
            <CenteredFormContainer>
                <Typography.Title style={{ textAlign: 'center' }} level={3}>
                    {Log_in[lang]}
                </Typography.Title>
                <Card>
                    <LoginForm onSubmit={handleSubmit} />
                    <Row align='bottom' justify='center'>
                        <Typography.Text>{Dont_have_an_account[lang]}
                            {NoBreakSpace}
                            <Link passHref href="/register">
                                <Typography.Link>
                                    {Sign_up[lang]}
                                </Typography.Link>
                            </Link>
                        </Typography.Text>
                    </Row>
                </Card>
            </CenteredFormContainer>

        </ContainerWithBackground>
    );
};

export default Login;
